import { memo } from 'react';
// Local files
import Item from './Item/Item';
import BaseAnalysesList from 'components/Analyses/Common/BaseAnalysesList/BaseAnalysesList';
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';
import useCustomSelector from 'hooks/useCustomSelector';
import useWaterfallAnalyses from 'hooks/useWaterfallAnalyses';
import { waterfallAnalysesSelectors } from "features/waterfallAnalyses";

const WaterfallAnalysesList = () => {
  const { getWaterfallAnalyses } = useWaterfallAnalyses();
  const { data, pagination } = useCustomSelector(waterfallAnalysesSelectors.getWaterfallAnalysesData);
  const fetching = useCustomSelector(waterfallAnalysesSelectors.waterfallAnalysesIsFetching);

  return (
    <BaseAnalysesList
      fetchData={getWaterfallAnalyses}
      getData={data}
      isFetching={fetching}
      pagination={pagination}
      renderItem={(item) => <Item key={item.id} {...item} />}
    />
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <WaterfallAnalysesList {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);